import axios from 'axios';

const hostname = process.env.REACT_APP_SERVICE_URL || 'localhost:3000';
const http = process.env.REACT_APP_HTTP || 'http';

const apiClient = axios.create({
  baseURL: `${http}://${hostname}/api`,
  withCredentials: true,
});

// --- THE UPDATED INTERCEPTOR ---
apiClient.interceptors.response.use(
  // On success, just return the response

  (response) => {
    console.log('[apiClient] response', response);
    return response;
  },

  // On error, process and reject with a richer error object
  (error) => {
    // Default error message
    let errorMessage = error.message;
    let errorDetails = null;

    // Check if the error is from a server response (e.g., a 4xx or 5xx status)
    if (error.response && error.response.data) {
      // Use the structured error message from our backend if it exists
      errorMessage = error.response.data.error || 'An unknown API error occurred.';
      // IMPORTANT: Preserve the 'details' field from our backend response
      errorDetails = error.response.data.details || null;
    }

    console.error('API Error:', errorMessage, 'Details:', errorDetails);

    // Create a new Error object to get a proper stack trace on the client side
    const customError = new Error(errorMessage);
    // Attach the crucial 'details' property
    customError.details = errorDetails;

    // Reject the promise with our new, more informative error object.
    // The .catch() block in our components will receive this object.
    return Promise.reject(customError);
  }
);

export default apiClient;
